import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = ({ settings }) => (
  <footer className="border-t border-border bg-charcoal px-5 py-14 md:px-10" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-3">
      <div>
        <Logo />
        <p className="mt-5 max-w-xs font-serif text-lg italic text-caramel">
          {settings.tagline || "Brewing Happiness, One Bite at a Time."}
        </p>
        <p className="mt-2 text-xs uppercase tracking-[0.2em] text-muted-foreground">
          {settings.secondary_tagline}
        </p>
      </div>

      <div>
        <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-cream">Explore</h4>
        <div className="mt-4 flex flex-col gap-2 text-sm text-cream/70">
          <a href="/#home" className="transition-colors hover:text-caramel" data-testid="footer-link-home">Home</a>
          <Link to="/menu" className="transition-colors hover:text-caramel" data-testid="footer-link-menu">Menu</Link>
          <a href="/#story" className="transition-colors hover:text-caramel" data-testid="footer-link-about">About</a>
          <a href="/#gallery" className="transition-colors hover:text-caramel" data-testid="footer-link-gallery">Gallery</a>
          <a href="/#contact" className="transition-colors hover:text-caramel" data-testid="footer-link-contact">Contact</a>
        </div>
      </div>

      <div>
        <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-cream">Find Us</h4>
        <p className="mt-4 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-cream/70" data-testid="footer-phone">
          <Phone className="h-4 w-4 shrink-0 text-copper" />
          {(settings.phone || "").split(",").map((num, i) => {
            const n = num.trim();
            return n ? (
              <a key={n} href={`tel:${n.replace(/\s/g, "")}`} data-testid={`footer-phone-link-${i}`}
                className="transition-colors hover:text-caramel">
                {n}{i === 0 && (settings.phone || "").split(",").filter((x) => x.trim()).length > 1 ? "," : ""}
              </a>
            ) : null;
          })}
        </p>
        {settings.email && (
          <p className="mt-2 flex items-center gap-2 text-sm text-cream/70" data-testid="footer-email">
            <Mail className="h-4 w-4 shrink-0 text-copper" />
            <a href={`mailto:${settings.email}`} className="break-all transition-colors hover:text-caramel">
              {settings.email}
            </a>
          </p>
        )}
        <div className="mt-5 flex gap-3">
          <a href={settings.instagram || "#"} target="_blank" rel="noreferrer" data-testid="footer-instagram"
            className="rounded-full border border-border p-2.5 text-cream/80 transition-colors hover:border-copper hover:text-caramel">
            <Instagram className="h-4 w-4" />
          </a>
          <a href={settings.facebook || "#"} target="_blank" rel="noreferrer" data-testid="footer-facebook"
            className="rounded-full border border-border p-2.5 text-cream/80 transition-colors hover:border-copper hover:text-caramel">
            <Facebook className="h-4 w-4" />
          </a>
          <a href={`https://wa.me/${settings.whatsapp || ""}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp"
            className="rounded-full border border-border p-2.5 text-cream/80 transition-colors hover:border-copper hover:text-caramel">
            <MessageCircle className="h-4 w-4" />
          </a>
        </div>
      </div>
    </div>
    <div className="mx-auto mt-12 max-w-7xl border-t border-border/60 pt-6 text-xs text-muted-foreground">
      © {new Date().getFullYear()} JH Brew Bites. All rights reserved. ·{" "}
      <Link to="/admin" className="hover:text-caramel" data-testid="footer-admin-link">Admin</Link>
    </div>
  </footer>
);
